import _extends from "@babel/runtime/helpers/extends";
import * as React from "react";
import { forwardRef } from "react";
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M4.67 3.323a.7.7 0 0 1 .7.7v10.259l5.634-4.428a.7.7 0 0 1 .865 1.1l-4.272 3.358 4.375 5.214a.7.7 0 0 1-1.072.9l-4.404-5.248-1.126.884v3.915a.7.7 0 1 1-1.4 0V4.023a.7.7 0 0 1 .7-.7m9.585 6.382a.7.7 0 0 1 .7.7v1.292q.215-.128.463-.255c.997-.506 2.427-.966 4.042-.662a.7.7 0 0 1-.26 1.376c-1.204-.227-2.311.11-3.148.534a7 7 0 0 0-1.097.699v6.588a.7.7 0 1 1-1.4 0v-9.572a.7.7 0 0 1 .7-.7",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M19.33 19.76a.862.862 0 1 1-1.725 0 .862.862 0 0 1 1.725 0"
}));
const ForwardRef = /*#__PURE__*/forwardRef(SvgComponent);
export default ForwardRef;
//# sourceMappingURL=CurrencyDanishKroneIcon24.js.map